import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import * as i0 from "@angular/core";
export class FiltersAthleteBiographyService extends FiltersAbstractService {
    constructor() {
        super();
    }
    /**
     * Method not required in this case, but it's abstract and must be implemented
     *
     * @memberof FiltersAthleteBiographyService
     */
    generateDefaultValues() {
        throw new Error("Method not implemented.");
    }
    /**
     * Method not required in this case, but it's abstract and must be implemented
     *
     * @memberof FiltersAthleteBiographyService
     */
    getDataStreamWithFilters() {
        throw new Error("Method not implemented.");
    }
}
FiltersAthleteBiographyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersAthleteBiographyService_Factory() { return new FiltersAthleteBiographyService(); }, token: FiltersAthleteBiographyService, providedIn: "root" });
